'use es6';

import { makeAsyncComponent, makeAsyncComponentWithOverlay } from 'ContentEditorUI/components/shared/makeAsyncUtils';
import AsyncMofoFields from './AsyncMofoFields';
const AsyncHtmlEditorModalContainer = makeAsyncComponentWithOverlay(() => {
  return Promise.all([import( /* webpackChunkName: 'HtmlEditorModalContainer' */'blog-editor-ui/components/LazyHtmlEditorModalContainer'), importDlb('codemirror-dlb/bundle.js')]).then(([mod]) => mod.default()).catch(() => {
    throw new Error('Error loading CodeMirror or dependent module');
  });
});
const AsyncPreviewModalContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'PreviewModalContainer' */'blog-editor-ui/containers/BlogPreviewModalContainer'));
const AsyncBlogAuthorPanel = makeAsyncComponent(() => import( /* webpackChunkName: 'BlogAuthorPanel' */'ContentComponents/components/blogAuthors/BlogAuthorPanel'));
export const AsyncCodeMirrorEditorField = makeAsyncComponent(() => {
  return Promise.all([import( /* webpackChunkName: 'CodeMirrorEditorField' */'blog-editor-ui/components/LazyCodeMirrorEditorField'), importDlb('codemirror-dlb/bundle.js')]).then(([mod]) => mod.default()).catch(() => {
    throw new Error('Error loading CodeMirror or dependent module');
  });
});
export const AsyncPostAdvancedSettingsContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'PostAdvancedSettingsContainer' */'blog-editor-ui/containers/PostAdvancedSettingsContainer'));
const AsyncBlogScopesHaveChangedModal = makeAsyncComponent(() => import( /* webpackChunkName: 'BlogScopesHaveChangedModal' */'blog-editor-ui/components/BlogScopesHaveChangedModal'));
const AsyncCampaignFieldContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'CampaignFieldContainer' */'ContentEditorUI/containers/settings/CampaignFieldContainer'));
const AsyncCollaborationSidebarContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'collaboration-sidebar-container' */'ContentEditorUI/containers/CollaborationSidebarContainer'));
const AsyncContentGenerationModalContainer = makeAsyncComponentWithOverlay(() => {
  return import( /* webpackChunkName: 'ContentGenerationModalContainer' */'tinymce-plugins/components/ContentGenerationModalContainer');
});
const AsyncPatagoniaSettingsModalContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'PatagoniaPageSettingsModalContainer' */'blog-editor-ui/containers/PatagoniaSettingsModalContainer'));
const AsyncPatagoniaOnboardingTourModalContainer = makeAsyncComponent(() => import( /* webpackChunkName: 'PatagoniaOnboardingTourModalContainer' */'blog-editor-ui/containers/PatagoniaOnboardingTourModalContainer'));
export const asyncComponentsOverrides = {
  extraComponents: {
    PreviewModalContainer: AsyncPreviewModalContainer,
    CampaignFieldContainer: AsyncCampaignFieldContainer,
    CodeMirrorEditorField: AsyncCodeMirrorEditorField,
    CollaborationSidebarContainer: AsyncCollaborationSidebarContainer,
    BlogAuthorPanel: AsyncBlogAuthorPanel,
    PostAdvancedSettingsContainer: AsyncPostAdvancedSettingsContainer,
    BlogScopesHaveChangedModal: AsyncBlogScopesHaveChangedModal,
    PatagoniaSettingsModalContainer: AsyncPatagoniaSettingsModalContainer,
    PatagoniaOnboardingTourModalContainer: AsyncPatagoniaOnboardingTourModalContainer
  },
  extraMofoFields: AsyncMofoFields,
  extraTinyMceModals: {
    HtmlEditorModalContainer: AsyncHtmlEditorModalContainer,
    ContentGenerationModalContainer: AsyncContentGenerationModalContainer
  }
};